import React from 'react';

import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { useTouchClick } from "shared/hooks/useTouchClick";
import rightIcon from "resources/img/puffu/right.png";
import leftIcon from "resources/img/puffu/left.png";
import styles from "./Pagination.module.css"


function SimplePagination({
  currentPage,
  totalPages,
  onPageChange,
  bottom
}) {
  const maxVisibleBullets = 5;

  const getVisiblePages = () => {
    const delta = Math.floor(maxVisibleBullets / 2);
    let start = currentPage - delta;
    let end = currentPage + delta;

    if (start < 1) {
      end += 1 - start;
      start = 1;
    }

    if (end > totalPages) {
      start -= end - totalPages;
      end = totalPages;
    }

    start = Math.max(start, 1);
    end = Math.min(end, totalPages);

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const getBulletStyle = (pageIndex) => {
    const distance = Math.abs(currentPage - pageIndex);
    const maxDistance = Math.floor(maxVisibleBullets / 2);
    const scale = Math.max(0.6, 1 - (distance * 0.15));
    const opacity = Math.max(0.3, 1 - (distance * 0.25));

    return {
      width: currentPage === pageIndex ? '24px' : `${12 * scale}px`,
      height: currentPage === pageIndex ? '24px' : `${12 * scale}px`,
      borderRadius: '50%',
      backgroundColor: currentPage === pageIndex ? 'var(--main-color)' : '#a0a0a0',
      border: currentPage === pageIndex ? "none" : "1px solid #a0a0a0",
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      opacity,
      transform: `scale(${scale})`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontWeight: 'bold',
    };
  };



  const { handleTouchStart: handlePrevTouchStart, handleTouchEnd: handlePrevTouchEnd } = useTouchClick(() => onPageChange('prev'), 10,()=>false,true);

  const { handleTouchStart: handleNextTouchStart, handleTouchEnd: handleNextTouchEnd } = useTouchClick(() => onPageChange('next'), 10,()=>false,true);

  return (
    <div style={{ display: totalPages <= 1 ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', bottom: bottom, width: '93%' }}>
      <div
        className={styles.btn}
        onPointerDown={handlePrevTouchStart}
        onPointerUp={handlePrevTouchEnd}
        style={{
          width: "400px",
          height: "44px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: currentPage === 1 ? "white" : "rgba(255, 121, 25, 1)",
          border: currentPage === 1 ? "1.5px solid rgba(255, 121, 25, 1)" : "white",
          color: "#fff",
          cursor: currentPage === 1 ? "default" : "pointer",
          borderRadius: '5px',
          padding: "26px 10px",
          transition: "transform 0.1s ease-in-out"
        }}
      >
        <HorizontalFlex>
          <FlexChild width={"40%"}>
            <img
              src={leftIcon}
              width={"10px"}
              style={{
                filter: currentPage !== 1 && "invert(50%) brightness(250%)"
              }}
            />
          </FlexChild>
          <FlexChild>
            <P
              font={"Pretendard"}
              weight={700}
              size={24}
              color={currentPage === 1 ? "rgba(255, 121, 25, 1)" : "white"}
            >
              이전
            </P>
          </FlexChild>
        </HorizontalFlex>
      </div>

      <div style={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        justifyContent: "center",
        margin: "0 20px",
        height: "44px",
        alignItems: "center"
      }}>
        {getVisiblePages().map((pageIndex, idx) => (
          <div
            key={pageIndex}
            style={getBulletStyle(pageIndex)}
          ><P size={18}>{currentPage === pageIndex && (pageIndex)}</P>
          </div>
        ))}
      </div>

      <div
       onPointerDown={handleNextTouchStart}
       onPointerUp={handleNextTouchEnd}
        style={{
          width: "400px",
          height: "44px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: currentPage !== totalPages ? "rgba(255, 121, 25, 1)" : "white",
          border: currentPage !== totalPages ?   "white" : "1.5px solid rgba(255, 121, 25, 1)",
          color: "#fff",
          cursor: currentPage !== totalPages ? "default" : "pointer",
          borderRadius: '5px',
          padding: "26px 10px"
        }}

      >
        <HorizontalFlex>
          <FlexChild justifyContent={"flex-end"}>
            <P
              font={"Pretendard"}
              weight={700}
              size={24}
              color={currentPage === totalPages ? "rgba(255, 121, 25, 1)" : "white"}
            >
              다음
            </P>
          </FlexChild>
          <FlexChild width={"40%"} justifyContent={"flex-end"}>
            <img
              src={rightIcon}
              width={"10px"}
              style={{
                filter: currentPage !== totalPages && "invert(50%) brightness(250%)"
              }}
            />
          </FlexChild>
        </HorizontalFlex>
      </div>
    </div>
  );
};

export default SimplePagination;
